import React from 'react';

import { useIntl } from 'react-intl';

import { Col, DatePicker, Form, Input, Row } from 'antd';

import Title from '@src/components/BoxContainer/components/Title';

const { Item } = Form;

interface ShiftPermissionProps {
  show?: boolean;
}

/**
 * Componente reutilizable para el formulario de permisos de la Dirección del Trabajo
 * @param props - Propiedades del componente
 * @param props.show - Controla si el componente debe mostrarse
 * @returns El componente del formulario o null si no debe mostrarse
 */
const ShiftPermission = ({ show = false }: ShiftPermissionProps) => {
  const intl = useIntl();

  if (!show) {
    return null;
  }

  return (
    <Row gutter={[8, 8]}>
      <Col span={24}>
        <Title.SubTitle value={intl.formatMessage({ id: 'shifts.permission.title' })} />
        <div className="gx-w-100 gx-w-sm-50">
          <Title.Description value={intl.formatMessage({ id: 'shifts.permission.description' })} />
        </div>
      </Col>

      <Col xs={24} md={12} lg={12} xl={12}>
        <Title.LabelForm
          className="gx-mb-2"
          value={intl.formatMessage({ id: 'shifts.permission.resolution.name' })}
        />
        <Item name={['resolution', 'name']}>
          <Input />
        </Item>
      </Col>
      <Col xs={24} md={12} lg={12} xl={12}>
        <Title.LabelForm
          className="gx-mb-2"
          value={intl.formatMessage({ id: 'shifts.permission.resolution.date' })}
        />
        <Item name={['resolution', 'date']}>
          <DatePicker className="gx-w-100" />
        </Item>
      </Col>
    </Row>
  );
};

export default ShiftPermission;
